<!--
 * @FileDescription: 自定义订单文件列表-Web
 * @Author: 陈文景
 * @Date: 2022-11-08 15:23:21
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.customSamples') }}</h3>

    <div v-show="tabs.length === 0" class="not-data">
      <img src="~@/assets/img/undraw_random_thoughts_re_cob6.svg" alt="img.svg" />
      <span class="tips-text">{{ $t('Order.Custom.Web.Index.NoRecord') }}</span>
    </div>

    <div id="custom-list" class="list">
      <el-tabs v-model="activeName">
        <el-tab-pane v-for="item in tabs" :key="item.fileUrl" :label="item.fileName" :name="item.fileUrl" />
      </el-tabs>
      <sample :shipped="shipped" :activeKey="+activeName" />
      <!-- <div v-if="activeName === 'Sample'">
        <sample />
      </div> -->
      <!-- <div v-else id="custom-content" class="content">
        <div class="export">
          <span class="text" @click="downloadFile">
            <i class="el-icon-download" />
            <span>{{ $t('Order.Custom.Web.Index.Export') }}</span>
          </span>
        </div>

        <div class="table-box">
          <el-table v-if="documentarys.length" ref="table" row-key="id" fit :data="documentarys" v-loading="loading" height="100%" :style="{ width: setTableWidth }">
            <el-table-column v-for="(item, index) in header" :key="index" :label="item.label" :fixed="item.isFixed && 'left'" :width="setTableWidth === '100%' ? null : item.width">
              <template #header>
                <div class="header-label">
                  <span v-html="item.label" />
                  <i class="fixed-nail iconfont icon-guding" :class="{ nail: item.isFlag }" @click="() => handleClickFlag(item)" />
                </div>
              </template>

              <template v-slot="{ row }">
                <el-popover v-if="validateURL(row[item.prop])" placement="right" trigger="hover">
                  <img class="content-img" :src="row[item.prop]" alt="img.png" />
                  <img slot="reference" class="goods-img" :src="row[item.prop]" alt="img.png" />
                </el-popover>
                <template v-else-if="item.label === 'Tracking Number'">
                  <a :href="`https://www.dhl.com/hk-zh/home/tracking/tracking-express.html?submit=1&tracking-id=${row[item.prop]}`" target="_blank">{{ row[item.prop] }}</a>
                </template>
                <span v-else v-html="row[item.prop]" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import API from '@/api'
import Papa from 'papaparse'
import { validateURL } from '@/util/validate'
import sample from './components/Sample.vue'

export default {
  data() {
    return {
      validateURL,

      fixedColumn: [0, 1, 2, 3],

      activeName: '1',

      customContentWidth: 0, // 表格父元素的宽度

      tabs: [
        {
          fileUrl: '1',
          fileName: 'Samples sent'
        },
        {
          fileUrl: '2',
          fileName: 'Samples to be sent'
        },
        {
          fileUrl: '3',
          fileName: 'TOP sent'
        },
        {
          fileUrl: '4',
          fileName: 'TOP to be sent'
        }
      ],
      header: [],
      documentarys: [],
      loading: false,

      sampleOrders: []
    }
  },
  components: {
    sample
  },
  computed: {
    /**
     * 动态设置表格的宽度
     */
    setTableWidth() {
      let width = this.header.reduce((previous, item) => {
        if (item) {
          previous += item.width
        }
        return previous
      }, 0)
      if (this.customContentWidth > width) {
        return '100%'
      } else {
        return `${width}px`
      }
    },
    shipped() {
      return [1, 3].includes(+this.activeName)
      // return !!(+this.activeName)
    }
  },
  watch: {
    /**
     * 自动设置表格列的宽度
     *
     * @param data 表格数据源
     */
    documentarys(data) {
      this.header = this.header.map((value) => {
        let arr = data.map((item) => item[value.prop])
        arr.push(value.label)
        value.width = this.getMaxLength(arr) + 80
        return value
      })
    }
  },
  created() {
    // this.getKeyCustomerSampleOrders()
  },
  mounted() {},
  methods: {
    getKeyCustomerSampleOrders() {
      API.getKeyCustomerSampleOrders({
        pageSize: 20,
        pageNumber: 1
      }).then(res => {
        this.sampleOrders = res.data.list || []
      }).finally(() => {
        this.getDocumentaryFileList()
      })
    },
    /**
     * API 获取跟单文件列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getDocumentaryFileList() {
      try {
        this.loading = true
        let { data } = await API.getDocumentaryFileList()
        this.tabs = data
        if (this.sampleOrders.length) {
          this.tabs.unshift({
            fileUrl: '1',
            fileName: 'Sample'
          })
        }
        if (this.tabs && this.tabs.length) {
          this.activeName = this.tabs[0].fileName
          await this.getGenerateTabeData(this.tabs[0].fileUrl)
          let customContentWidth = document.getElementById('custom-content')
          if (customContentWidth) {
            this.customContentWidth = customContentWidth.offsetWidth
          }
        }
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * Tabs切换时的回调
     */
    handleClickTabs() {
      let result = this.tabs.find((item) => item.fileName === this.activeName)
      if (result.fileName === 'Ross_Sample') {
        return
      }
      if (result) {
        this.getGenerateTabeData(result.fileUrl)
      }
    },

    /**
     * 点击某个表头的小旗帜
     *
     * @param {Object} header
     */
    handleClickFlag(header) {
      let index = 0
      this.header.forEach((item, i) => {
        if (item.label === header.label) {
          index = i
        }
      })
      this.header.forEach((item, i) => {
        if (i <= index) {
          item.isFlag = true
          item.isFixed = true
        } else {
          item.isFlag = false
          item.isFixed = false
        }
      })
    },

    /**
     * 生成表格数据的方法
     *
     * @param {Boolean} fileUrl 文件路径
     */
    async getGenerateTabeData(fileUrl) {
      this.documentarys = []
      let data = await API.getDocumentaryFile(fileUrl)
      let reader = new FileReader()
      reader.readAsText(data, 'GB2312')
      reader.onload = (event) => {
        if (event.target && event.target.result) {
          let result = Papa.parse(event.target.result)
          if (result.data.length >= 2) {
            result.data.pop()
          }
          let header = result.data.shift()
          if (header && header.length) {
            this.header = header.map((item, index) => ({
              label: item.trim(),
              prop: item.trim(),
              width: null,
              isFixed: !![0, 1, 2, 3].includes(index),
              isFlag: !![0, 1, 2, 3].includes(index)
            }))
          }
          let sum = 0
          if (result.data.length) {
            sum = result.data[0].length
            for (let i = 1; i <= result.data.length; i++) {
              if (result.data[i] && result.data[i].length > sum) {
                sum = result.data[i].length
              }
            }
          }
          let index = 1
          this.header.forEach((item) => {
            if (!item.label && !item.prop) {
              item.label = `unknown ${index}`
              item.prop = `unknown ${index}`
              index++
            }
          })
          if (sum > this.header.length) {
            let num = sum - this.header.length
            for (let i = 1; i <= num; i++) {
              this.header.push({
                label: `unknown ${index}`,
                prop: `unknown ${index}`,
                width: null,
                isFixed: !![0, 1, 2, 3].includes(index),
                isFlag: !![0, 1, 2, 3].includes(index)
              })
              index++
            }
          }
          result.data.forEach((item) => {
            let temporary = {}
            item.forEach((field, index) => {
              temporary[this.header[index].label] = field
            })
            this.documentarys.push({ ...temporary })
          })
        }
      }
    },

    /**
     * 遍历列的所有内容
     * 获取最宽一列的宽度
     *
     * @param arr 所有列的数据
     */
    getMaxLength(arr) {
      return arr.reduce((previous, item) => {
        if (item) {
          let calcLen = this.getTextWidth(item)
          if (previous < calcLen) {
            previous = calcLen
          }
        }
        return previous
      }, 0)
    },

    /**
     * 使用span标签包裹内容
     * 然后计算span的宽度
     *
     * @param str 列的内容
     */
    getTextWidth(str) {
      if (this.validateURL(str)) {
        return 68
      } else {
        let width = 0
        let element = document.createElement('span')
        element.innerText = str
        element.className = 'getTextWidth'
        document.querySelector('body').appendChild(element)
        width = document.querySelector('.getTextWidth').offsetWidth
        document.querySelector('.getTextWidth').remove()
        return width
      }
    },

    /**
     * 下载文件
     */
    downloadFile() {
      let result = this.tabs.find((item) => item.fileName === this.activeName)
      if (result) {
        window.open(result.fileUrl)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header-label {
  width: 100%;
  display: inline-block;
  &:hover {
    .fixed-nail {
      display: inline-block;
    }
  }
  .fixed-nail {
    display: none;
    color: #99c41c;
    font-weight: 400;
    margin-left: 2px;
    cursor: pointer;
    &:hover {
      color: #f56c6c;
    }
    &.nail {
      color: #f56c6c;
      display: inline-block;
    }
  }
}

.content-img,
.goods-img {
  border-radius: 4px;
  object-fit: cover;
}

.content-img {
  width: 228px;
  height: 228px;
}

.goods-img {
  width: 68px;
  height: 68px;
  cursor: pointer;
}

.container {
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }

  .not-data {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 128px 0;
    background-color: #fff;
    .tips-text {
      color: #747a87;
      font-size: 16px;
      line-height: 24px;
      margin-top: 44px;
    }
  }

  .list {
    padding: 10px 16px;
    padding-bottom: 8px;
    background-color: #fff;
    .content {
      .export {
        display: flex;
        margin-bottom: 15px;
        align-items: center;
        justify-content: flex-end;
        .text {
          color: #99c41c;
          user-select: none;
          cursor: pointer;
          i {
            margin-right: 5px;
          }
        }
      }
      .table-box {
        height: calc(100vh - 249px);
        /deep/.el-table th.el-table__cell.is-leaf,
        .el-table td.el-table__cell {
          color: #10141d;
          font-size: 14px;
          font-weight: 500;
          background: rgba(0, 0, 0, 0.02);
        }
      }
    }

    /deep/ .el-tabs__header{
      margin-bottom: 8px;
    }
  }

  a:link,
  a:visited,
  a:hover,
  a:active {
    color: #99c41c;
    text-decoration: none;
  }
}
</style>
